import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import arrow_back from '../assets/images/arrow-back.svg';
import logo_pop from '../assets/images/logo-pop.png';
import ProfileHeader from '../components/ProfileHeader';
import * as globals from '../globals.js';
import ApiService from '../services/ApiService';
import NotificationService from '../services/NotificationService';
import EDSFooter from './EDSFooter';
import Promotions from './Promotions';
 

export default class WizardStep4 extends Component {
    courseHeading = null;
    userData = null;
    userCardsData = null;
    //userId used to calculate promos ()
    promoUserId = null;

    constructor() {
        super();
        this.apiService = ApiService.getInstance();
        this.notificationService = NotificationService.getInstance();
        this.state = {
            obligatoryDataProvided: false,
            loading: false,
            selectedPaymentMethod: null,
            selectedCard: null,
        };

        this.promotionsComponent = React.createRef();
    }

    componentDidMount() {
        if (typeof this.props.paymentData === 'object' && this.props.paymentData !== null) {
            let selectedPaymentMethod = null;
            let selectedCard = null;
            if (typeof this.props.paymentData.selectedPaymentMethod === 'number' &&
                this.props.paymentData.selectedPaymentMethod > 0) {
                selectedPaymentMethod = this.props.paymentData.selectedPaymentMethod;
            }if (
                typeof this.props.paymentData.selectedCard === 'number' &&
                this.props.paymentData.selectedCard > 0
            ) {
                selectedCard = this.props.paymentData.selectedCard;
            }

            this.setState(
                {
                    selectedPaymentMethod: selectedPaymentMethod,
                    selectedCard: selectedCard,
                },
                () => {
                    this.emitPaymentMethod();
                }
            );
        }

        this.loadData((success) => {
            if (typeof success === 'boolean' && success) {
                this.setState({ obligatoryDataProvided: true });
            } else {
                // problem podczas pobierania danych użytkownika
                this.notificationService.showError();
            }
        });
    }

    loadData(callback) {
        const end = (result) => {
            this.setState({ loading: false });
            if (typeof callback === 'function') {
                callback(result);
            }
        };

        this.setState({ loading: true });
        this.apiService.apiGet('UserGet', (response) => {
            if (response.success) {
                const userData = response.data;
                if (
                    typeof this.props.selectedParticipant === 'object' &&
                    this.props.selectedParticipant !== null &&
                    typeof this.props.selectedParticipant.usersID === 'number' &&
                    this.props.selectedParticipant.usersID > 0
                ) {
                    this.promoUserId = this.props.selectedParticipant.usersID;
                } else {
                    this.promoUserId = userData.usersID;
                }

                const payload = { usersID: userData.usersID, current_LocalizationsID: 0 };
                this.apiService.apiPost('getUserCards', payload, (response2) => {
                    if (response2.success) {
                        this.userData = userData;
                        this.userCardsData = response2.data;
                        end(true);
                    } else {
                        end(false);
                    }
                });
            } else {
                end(false);
            }
        });
    }

    render() {
        return (
            <>
                <header className="header">
                    <div className="header__image-box">
                        <a href="">
                            <img
                                src={logo_pop}
                                alt="Logo Egurrola Dance Studio"
                                className="header__image"
                            />
                        </a>
                    </div>
                    <div className="header__caption-box">
                        <span className="header__caption">
                            Proces zakupu kursu: {localStorage.getItem('courseHeadingName')}
                        </span>
                    </div>
                </header>
                <div className="content">
                    <a href="#">
                        <Link to="/Wybor_opcji_3_wariant">
                            <img src={arrow_back} alt="arrow_back" className="arrow-back" />
                        </Link>
                    </a>
                    <ProfileHeader></ProfileHeader>
                    <aside className="registration-steps margin-top-32">
                        <div className="step">
                            <div className="step__circle step__circle--active">
                                <span className="step__count">1</span>
                            </div>
                            <span className="step__text">Wybór&nbsp;kursu</span>
                        </div>
                        <div className="step">
                            <div className="step__circle">
                                <span className="step__count">2</span>
                            </div>
                            <span className="step__text">Umowa</span>
                        </div>
                        <div className="step">
                            <div className="step__circle">
                                <span className="step__count">3</span>
                            </div>
                            <span className="step__text">Płatność</span>
                        </div>
                    </aside>

                    <aside className="registration-course-steps margin-top-16">
                        <span className="step">Uczestnik</span>
                        <div className="hyphen"></div>
                        <span className="step">Data</span>
                        <div className="hyphen"></div>
                        <span className="step">Wariant</span>
                        <div className="hyphen"></div>
                        <span className="step step--active">Forma płatności i rabat</span>
                        <div className="hyphen"></div>
                        <span className="step">Raty</span>
                    </aside>

                    {this.renderForm()}
                </div>
                <EDSFooter></EDSFooter>
            </>
        );
    }

    // const dispatch = useDispatch();
    renderForm() {
        if (this.state.loading) {
            return <></>;
        } else {
            if (this.state.obligatoryDataProvided) {
                const that = this;

                return (
                    <main className="responsive-padding">
                        <section className="course-options-payment margin-top-64">
                            <h2 className="h2">Forma płatności</h2>
                            <form
                                id="course-options-payment-form"
                                className="margin-top-32"
                                method="post"
                                action=""
                                onSubmit={(e) => that.save(e)}
                            >
                                <fieldset>
                                    <legend className="h3">Wybierz formę płatności</legend>
                                    <ul className="payment-method-list margin-top-16">
                                        <li className="payment-method">
                                            <input
                                                className="form__radio"
                                                type="radio"
                                                id="payment-method-przelewy24"
                                                name="payment-method"
                                                value={5}
                                                checked={this.state.selectedPaymentMethod === 5}
                                                onChange={(e) => {
                                                    this.setState(
                                                        {
                                                            selectedPaymentMethod: 5,
                                                            selectedCard: null,
                                                        },
                                                        () => {
                                                            this.emitPaymentMethod();
                                                        }
                                                    );
                                                }}
                                                required
                                            />
                                            <label
                                                htmlFor="payment-method-przelewy24"
                                                className="form__label--checkbox"
                                            >
                                                Przelewy 24
                                            </label>
                                        </li>
                                        {this.renderUserCards()}
                                    </ul>
                                    <div>
                                        <button
                                            className="btn-secondary-responsive btn-secondary-responsive--small margin-top-32"
                                            type="button"
                                            onClick={() => that.registerNewCard()}
                                        >
                                            Zarejestruj kartę płatniczą
                                        </button>
                                    </div>
                                </fieldset>

                                <Promotions
                                    ref={this.promotionsComponent}
                                    userId={this.promoUserId}
                                    courseHeading={this.props.courseHeading}
                                    selectedProduct={this.props.selectedProduct}
                                    promotionsData={this.props.promotionsData}
                                    onChange={(promotionsData) => {
                                        this.emitPromotions(promotionsData);
                                    }}
                                ></Promotions>

                                <input
                                    type="submit"
                                    className={`btn-primary margin-top-64 margin-bottom-32 ${this.formValid() ? '' : 'button-disabled'
                                        }`}
                                    value="Dalej"
                                />
                            </form>
                        </section>
                    </main>
                );
            } else {
                return <></>;
            }
        }
    }

    renderUserCards() {
        const cardsAvailable = this.userCardsData.length > 0;

        return (
            <>
                <li className="payment-method">
                    <input
                        className="form__radio"
                        type="radio"
                        id="payment-method-creditcard"
                        name="payment-method"
                        value={3}
                        checked={this.state.selectedPaymentMethod === 6}
                        onChange={(e) => {
                            this.setState({ selectedPaymentMethod: 6 }, () => {
                                this.emitPaymentMethod();
                            });
                        }}
                        required
                        disabled={!cardsAvailable}
                    />
                    <label htmlFor="payment-method-creditcard" className="form__label--checkbox">
                        Karta kredytowa lub debetowa
                        {cardsAvailable ? (
                            <></>
                        ) : (
                            <div className="boldtext">
                                Nie masz obecnie zarejestrowanej żadnej karty.
                            </div>
                        )}
                    </label>
                </li>

                {cardsAvailable ? (
                    <ul>
                        {this.userCardsData.map((item) => (
                            <>
                                <li className="payment-method payment-method-card">
                                    <input
                                        className="form__radio payment-method__input"
                                        type="radio"
                                        id={'credit-card-' + item.paymentCardID}
                                        name="credit-card"
                                        value={item.paymentCardID}
                                        
                                        checked={this.state.selectedCard === item.paymentCardID}
                                        onChange={(e) => {
                                            this.setState(
                                                {
                                                    selectedCard: item.paymentCardID,
                                                    selectedPaymentMethod: 6,
                                                },
                                                () => {
                                                    this.emitPaymentMethod();
                                                }
                                            );
                                        }}
                                    />
                                    <label
                                        htmlFor={'credit-card-' + item.paymentCardID}
                                        className="form__label--checkbox"
                                    >
                                        {globals.getReadableCreditCardInfo(item)}
                                    </label>
                                </li>
                            </>
                        ))}
                    </ul>
                ) : (
                    <></>
                )}
            </>
        );
    }

    emitPaymentMethod() {
        const obj = {
            selectedPaymentMethod: this.state.selectedPaymentMethod,
            selectedCard: this.state.selectedCard,
        };

        // emit to parent
        if (typeof this.props.onPaymentDataChange === 'function') {
            this.props.onPaymentDataChange(obj);
        }

        // emit to promotions component to reload promotions by selected payment method
        if (
            typeof this.promotionsComponent === 'object' &&
            this.promotionsComponent !== null &&
            typeof this.promotionsComponent.current === 'object' &&
            this.promotionsComponent.current !== null &&
            typeof this.promotionsComponent.current.paymentMethodChanged === 'function'
        ) {
            this.promotionsComponent.current.paymentMethodChanged(obj);
        }
    }

    emitPromotions(promotionsData) {
        if (typeof this.props.onPromotionsChange === 'function') {
            this.props.onPromotionsChange(promotionsData);
        }
    }

    formValid() {
        if (this.state.selectedPaymentMethod !== null) {
            if (this.state.selectedPaymentMethod === 5) {
                return true;
            } else if (this.state.selectedPaymentMethod === 6) {
                if (this.state.selectedCard !== null) {
                    return true;
                } else return false;
            } else return false;
        } else {
            return false;
        }
    }

    save(e) {
        
        e.preventDefault();
        if (this.formValid()) {
            if (typeof this.props.finished === 'function') {
                this.props.finished();
            }
        }

        // if (
        //     typeof this.state.selectedPaymentMethod === 'number' &&
        //     this.state.selectedPaymentMethod > 0
        // ) {
        //     if (this.state.selectedPaymentMethod === 5) {
        //         // przelewy24
        //         if (typeof this.props.finished === 'function') {
        //             this.props.finished({ paymentMethod: this.state.selectedPaymentMethod });
        //         }
        //     } else if (this.state.selectedPaymentMethod === 6) {
        //         // karta
        //         if (typeof this.state.selectedCard === 'number' && this.state.selectedCard > 0) {
        //             if (typeof this.props.finished === 'function') {
        //                 this.props.finished({
        //                     paymentMethod: this.state.selectedPaymentMethod,
        //                     cardId: this.state.selectedCard,
        //                 });
        //             }
        //         } else {
        //             this.notificationService.showError('Wybierz kartę płatniczą');
        //         }
        //     }
        // } else {
        //     this.notificationService.showError('Wybierz formę płatności');
        // }
    }

    registerNewCard() {

        const cardData = {
            usersID: this.userData.usersID,
            localizationsID: this.props.courseHeading.localizationsID,
            current_LocalizationsID: this.props.courseHeading.localizationsID,
            returnURL: 'Wybor_opcji_4_forma_platnosci/'
        };

        this.apiService.apiPost('RegisterCard', cardData, (response) => {
            const error = () => {
                this.notificationService.showError();
            };

            if (
                response.success &&
                typeof response.data === 'object' &&
                response.data !== null &&
                response.data.succeeded === true &&
                typeof response.data.responseBody === 'object' &&
                response.data.responseBody !== null &&
                response.data.responseBody.status === 200 &&
                typeof response.data.responseBody.body === 'string'
            ) {
                try {
                    const p24Response = JSON.parse(response.data.responseBody.body);
                    if (typeof p24Response.url === 'string' && p24Response.url.length > 0) {
                        window.location.replace(p24Response.url);
                    } else {
                        error();
                    }
                } catch (ex) {
                    error();
                }
            } else {
                error();
            }
        });
    }
}
